import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getActivityGroupFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.activity_groups.code.label',
      contentValue: `{{ ${entity}activityGroup.code }}`,
      description: 'templates.activity_groups.code.description',
    },
    {
      label: 'templates.activity_groups.name.label',
      contentValue: `{{ ${entity}activityGroup.name }}`,
      description: 'templates.activity_groups.name.description',
    },
    {
      label: 'templates.activity_groups.min_enrollments.label',
      contentValue: `{{ ${entity}activityGroup.min_enrollments }}`,
      description: 'templates.activity_groups.min_enrollments.description',
    },
    {
      label: 'templates.activity_groups.max_enrollments.label',
      contentValue: `{{ ${entity}activityGroup.max_enrollments }}`,
      description: 'templates.activity_groups.max_enrollments.description',
    },
    {
      label: 'templates.activity_groups.min_age.label',
      contentValue: `{{ ${entity}activityGroup.min_age }}`,
      description: 'templates.activity_groups.min_age.description',
    },
    {
      label: 'templates.activity_groups.max_age.label',
      contentValue: `{{ ${entity}activityGroup.max_age }}`,
      description: 'templates.activity_groups.max_age.description',
    },
    {
      label: 'templates.activity_groups.start_date.label',
      contentValue: `{{ ${entity}activityGroup.start_date | date("d/m/Y") }}`,
      description: 'templates.activity_groups.start_date.description',
    },
    {
      label: 'templates.activity_groups.end_date.label',
      contentValue: `{{ ${entity}activityGroup.end_date | date("d/m/Y") }}`,
      description: 'templates.activity_groups.end_date.description',
    },

    // {
    //   label: 'templates.activity_groups.publish_start_date_time.label',
    //   contentValue: `{{ ${entity}activityGroup.publish_start_date_time }}`,
    //   description: 'templates.activity_groups.publish_start_date_time.description',
    // },
    // {
    //   label: 'templates.activity_groups.publish_end_date_time.label',
    //   contentValue: `{{ ${entity}activityGroup.publish_end_date_time }}`,
    //   description: 'templates.activity_groups.publish_end_date_time.description',
    // },
    // {
    //   label: 'templates.activity_groups.enrollment_start_date_time.label',
    //   contentValue: `{{ ${entity}activityGroup.enrollment_start_date_time }}`,
    //   description: 'templates.activity_groups.enrollment_start_date_time.description',
    // },
    // {
    //   label: 'templates.activity_groups.enrollment_end_date_time.label',
    //   contentValue: `{{ ${entity}activityGroup.enrollment_end_date_time }}`,
    //   description: 'templates.activity_groups.enrollment_end_date_time.description',
    // },
  ];
};

export const templateActivityGroup: EntityTemplateVariables = {
  fields: getActivityGroupFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
